import React, { useEffect, useState } from "react";
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";
import api, { formatMoney, formatNumber } from "../../lib/api";
import { Card } from "../labresumen/Charts";

const MESES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
const etiqueta = (m) => `${MESES[+m.slice(5, 7) - 1]} ${m.slice(0, 4)}`;

function Tip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  const r = payload[0].payload;
  return (
    <div className="bg-white border border-slate-200 rounded-md shadow-sm px-3 py-2 text-xs">
      <div className="font-bold mb-1">{etiqueta(label)}</div>
      {r.ventas != null && <div>Ventas: <b>{formatMoney(r.ventas)}</b> · {formatNumber(r.uds)} uds
        <div><span style={{ color: C.vf }}>Farmacia {formatMoney(r.ventas_farmacia || 0)}</span> · <span style={{ color: C.vp }}>Parafarmacia {formatMoney(r.ventas_parafarmacia || 0)}</span></div></div>}
      {r.stock_pvp != null && <div className="mt-1">Stock (PVP): <b>{formatMoney(r.stock_pvp)}</b> · {formatNumber(r.stock_uds)} uds
        <div><span style={{ color: C.sf }}>Farmacia {formatMoney(r.stock_farmacia || 0)}</span> · <span style={{ color: C.sp }}>Parafarmacia {formatMoney(r.stock_parafarmacia || 0)}</span></div>
        <div className="text-slate-500">Inventario «{r.inventario}» del {new Date(r.fecha_inventario).toLocaleDateString("es-ES")}</div></div>}
    </div>
  );
}

const C = { vf: "#0284c7", vp: "#8b5cf6", sf: "#0c4a6e", sp: "#c026d3" };
const hay = (rows, k) => rows.some((r) => (r[k] || 0) > 0);

export function EvolucionStockVentas({ lab, seg, familia }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    setD(null);
    api.get("/lab-analisis/evolucion", { params: { laboratorio: lab, segment: seg, familia: familia || undefined } })
      .then((r) => setD(r.data)).catch(() => setD({ meses: [], inventarios: 0 }));
  }, [lab, seg, familia]);
  if (!d) return null;
  return (
    <Card title="Stock y ventas en el tiempo" testid="la-evolucion"
          sub={`Barras: ventas de cada mes subido (Farmacia y Parafarmacia apiladas). Líneas: stock a PVP de cada canal en cada inventario subido (${d.inventarios} ${d.inventarios === 1 ? "inventario" : "inventarios"}).`}>
      {!d.meses.length ? <p className="text-sm text-slate-500 py-6 text-center" data-testid="la-evolucion-vacio">Todavía no hay meses de ventas ni inventarios para este laboratorio.</p> : (
        <ResponsiveContainer width="100%" height={300}>
          <ComposedChart data={d.meses}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
            <XAxis dataKey="mes" tickFormatter={etiqueta} tick={{ fontSize: 11 }} minTickGap={24} />
            <YAxis yAxisId="v" tick={{ fontSize: 11 }} tickFormatter={(v) => formatMoney(v)} width={78} />
            <YAxis yAxisId="s" orientation="right" tick={{ fontSize: 11, fill: "#64748b" }} tickFormatter={(v) => formatMoney(v)} width={84} />
            <Tooltip content={<Tip />} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            {hay(d.meses, "ventas_farmacia") && <Bar yAxisId="v" stackId="v" dataKey="ventas_farmacia" name="Ventas Farmacia" fill={C.vf} />}
            {hay(d.meses, "ventas_parafarmacia") && <Bar yAxisId="v" stackId="v" dataKey="ventas_parafarmacia" name="Ventas Parafarmacia" fill={C.vp} radius={[3, 3, 0, 0]} />}
            {hay(d.meses, "stock_farmacia") && <Line yAxisId="s" dataKey="stock_farmacia" name="Stock Farmacia (PVP)" stroke={C.sf} strokeWidth={2.5} connectNulls
                  dot={{ r: 6, fill: C.sf, stroke: "#fff", strokeWidth: 2 }} activeDot={{ r: 8 }} />}
            {hay(d.meses, "stock_parafarmacia") && <Line yAxisId="s" dataKey="stock_parafarmacia" name="Stock Parafarmacia (PVP)" stroke={C.sp} strokeWidth={2.5} strokeDasharray="6 3" connectNulls
                  dot={{ r: 6, fill: C.sp, stroke: "#fff", strokeWidth: 2 }} activeDot={{ r: 8 }} />}
          </ComposedChart>
        </ResponsiveContainer>
      )}
    </Card>
  );
}
